<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-02-06 11:05:00
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-02-06 11:09:19
 * @FilePath: \crm-product\src\views\dms\views\terminal\filiale_scan_in\table\table.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';
import DetailForm from '../form/detail.vue';

export default {
  extends: TablePage,
  name: 'main_list',
  components: {
    DetailForm,
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 按钮点击事件
    modalClick({ val, row }) {
      if (['detail'].includes(val.code)) {
        this.formConfig = {};
        this.formName = 'DetailForm';
        this.modalConfig.width = '85%';
        this.modalConfig.title = '明细';
        this.formConfig = {
          row,
          code: val.code || '',
        };
        this.openFull();
      }
    },
  },
};
</script>
